import ToggleThemeButton from "./toggle-theme-button"
ToggleThemeButton.install = (Vue) =>
  Vue.component(ToggleThemeButton.name, ToggleThemeButton)
export default ToggleThemeButton
